import getThreadId from '@/lib/threads/getThreadId.js';
import normalizeThreadType from '@/lib/threads/normalizeThreadType.js';

const EMPTY_THREADS = [];
const EMPTY_THREADS_BY_TYPE = {
  schedules: EMPTY_THREADS,
  triggers: EMPTY_THREADS,
  workflows: EMPTY_THREADS
};

const buildThreadsByType = ({ threads = [] } = {}) => {
  if (!Array.isArray(threads) || threads.length < 1) {
    return EMPTY_THREADS_BY_TYPE;
  }

  const nextByType = {
    schedules: [],
    triggers: [],
    workflows: []
  };

  for (const thread of threads || []) {
    const threadId = getThreadId(thread);

    if (!threadId) {
      continue;
    }

    const threadType = normalizeThreadType(thread?.threadType || thread?.thread_type, 'default');

    if (threadType === 'schedule' || threadType === 'schedule_run') {
      nextByType.schedules.push(thread);
      continue;
    }

    if (threadType === 'trigger' || threadType === 'trigger_run') {
      nextByType.triggers.push(thread);
      continue;
    }

    if (threadType === 'workflow') {
      nextByType.workflows.push(thread);
    }
  }

  if (nextByType.schedules.length < 1 && nextByType.triggers.length < 1 && nextByType.workflows.length < 1) {
    return EMPTY_THREADS_BY_TYPE;
  }

  return nextByType;
};

export default buildThreadsByType;
